<template>
    <v-row no-gutters :class="mobile_content ? 'mx-2 mt-4' : 'mx-4 mt-8'">
        <v-col cols="12">
            <v-dialog
                v-model="profile_syncing"
                hide-overlay
                persistent
                width="300"
            >
                <v-card
                    color="primary"
                    dark
                >
                    <v-card-text>
                        Loading profile...
                        <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                        ></v-progress-linear>
                    </v-card-text>
                
                </v-card>
            </v-dialog>
        </v-col>

        <v-col cols="12">
            <v-row>
                <v-col :cols="mobile_content ? 12 : 4">
                    <v-card dark class="pa-0 fill-height">
                        <v-toolbar height="36" dense class="grey darken-3">
                                <v-toolbar-title class="body-2 font-weight-bold">User Details</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text class="pa-2">
                            <div>
                                {{this.profile_details.name}}
                                <v-btn class="float-right" depressed x-small color="primary" @click="edit_username">Change Username</v-btn>
                            </div>
                            <div class="mt-2">
                                {{this.profile_details.email_address}}
                                <v-btn v-if="!linkedin_login" class="float-right" depressed x-small color="primary" @click="edit_password">Change Password</v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col :cols="mobile_content ? 12 : 4">
                    <v-card dark>
                        <v-toolbar height="36" dense class="grey darken-3">
                            <v-toolbar-title class="body-2 font-weight-bold">Access Key</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text class="pa-2">
                            {{this.profile_details.access_key || "-"}}
                            <v-btn depressed x-small color="primary" @click="generate_access_key">Generate New Key</v-btn>
                            <v-card color="grey darken-3 mt-2">
                                <v-card-text>
                                    Provide the Access Key for others to only access your files.
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col :cols="mobile_content ? 12 : 4">
                    <v-card dark class="fill-height">
                        <v-toolbar height="36" dense class="grey darken-3">
                            <v-toolbar-title class="body-2 font-weight-bold">Service Plan</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text class="pa-2">
                            {{this.profile_details.service_plan || "-"}}
                            <v-btn class="float-right" depressed x-small color="primary" @click="edit_service_plan">Change</v-btn>
                            <v-card color="grey darken-3 mt-2">
                                <v-card-text>
                                    <a target="_blank" :href="this.profile_details.service_plans_info_link">Click here</a> to know more about the service plans.
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col :cols="mobile_content ? 12 : 4">
                    <v-card dark>
                        <v-toolbar height="36" dense class="grey darken-3">
                            <v-toolbar-title class="body-2 font-weight-bold">Credit Overdraft Limit</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text class="pa-2">
                            {{this.profile_details.credits_overdraft_limit}}
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col :cols="mobile_content ? 12 : 4">
                    <v-card dark>
                        <v-toolbar height="36" dense class="grey darken-3">
                            <v-toolbar-title class="body-2 font-weight-bold">Number of machines per job</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text class="pa-2">
                            {{this.profile_details.job_throughput_limit}}
                            <v-btn class="float-right" depressed x-small color="primary" @click="edit_machine_throughput">Change</v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col :cols="mobile_content ? 12 : 4" v-for="machine in profile_details.machine_preferences" :key="machine.operation_type_id">
                    <v-card dark>
                        <v-toolbar height="32" dense class="grey darken-3">
                            <v-toolbar-title class="body-2 font-weight-bold">{{machine.operation_type_name}}</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text class="pa-2">
                            {{machine.machine_type_name || "-"}}
                            <v-btn class="float-right" depressed x-small color="primary" @click="edit_machine_prefrence(machine)">Change</v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-dialog v-model="username_dialog" width="400" overlay-opacity="0.6">
                    <v-form width="250" ref="change_username" lazy-validation>
                        <v-card width="100%">
                            <v-alert v-if="username_error" class="error my-0 pa-2" tile>
                                <v-icon small class="pb-1">warning</v-icon>
                                <span class="subtitle-1 font-weight-medium pl-2">{{username_error}}</span>
                            </v-alert>
                            <v-btn class="float-right" fab dark small text @click="username_dialog=false">
                                <v-icon dark>mdi-close</v-icon>
                            </v-btn>
                            <v-card-title>
                                <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Update Name</span>
                            </v-card-title>
                            <v-card-text class="py-0">
                                <v-container class="pa-0">
                                    <v-row>
                                        <v-col class="py-0" cols="12">
                                            <v-text-field
                                                v-model="username"
                                                label="Username"
                                                type="string"
                                                :rules="username_rules"
                                                @keydown.enter.prevent="update_username"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" depressed x-small @click="update_username">Update</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>

                <v-dialog v-model="password_dialog" width="400" overlay-opacity="0.6">
                    <v-form width="250" ref="change_password" lazy-validation>
                        <v-card width="100%">
                            <v-alert v-if="password_error" class="error my-0 pa-2" tile>
                                <v-icon small class="pb-1">warning</v-icon>
                                <span class="subtitle-1 font-weight-medium pl-2">{{password_error}}</span>
                            </v-alert>
                            <v-btn class="float-right" fab dark small text @click="password_dialog=false">
                                <v-icon dark>mdi-close</v-icon>
                            </v-btn>
                            <v-card-title>
                                <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Update Password</span>
                            </v-card-title>
                            <v-card-text class="py-0">
                                <v-container class="pa-0">
                                    <v-row>
                                        <v-col class="py-0" cols="12">
                                            <v-text-field
                                                v-model="password"
                                                label="New Password"
                                                type="password"
                                                :rules="password_rules"
                                                @keydown.enter.prevent="update_password"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0" cols="12">
                                            <v-text-field
                                                v-model="confirm_password"
                                                label="Confirm Password"
                                                type="password"
                                                :rules="confirm_password_rules"
                                                @keydown.enter.prevent="update_password"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" depressed x-small @click="update_password">Update</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>

                <v-dialog v-model="machine_throughput_dialog" width="400" overlay-opacity="0.6">
                    <v-form width="250" ref="change_machine_throughput" lazy-validation>
                        <v-card width="100%">
                            <v-alert v-if="machine_selection_error" class="error my-0 pa-2" tile>
                                <v-icon small class="pb-1">warning</v-icon>
                                <span class="subtitle-1 font-weight-medium pl-2">{{machine_throughput_error}}</span>
                            </v-alert>
                            <v-btn class="float-right" fab dark small text @click="machine_throughput_dialog=false">
                                <v-icon dark>mdi-close</v-icon>
                            </v-btn>
                            <v-card-title>
                                <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Update Job Throughtput</span>
                            </v-card-title>
                            <v-card-text class="py-0">
                                <v-container class="pa-0">
                                    <v-row>
                                        <v-col class="py-0" cols="12">
                                            <v-text-field
                                                v-model="machine_throughput"
                                                label="Job Throughtput"
                                                type="number"
                                                :max="profile_details.max_throughput"
                                                min="1"
                                                :rules="throughput_rules"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" depressed x-small @click="update_machine_throughput">Update</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>

                <v-dialog v-model="machine_selection_dialog" width="400" overlay-opacity="0.6">
                    <v-form width="250" ref="change_machine_selection" lazy-validation>
                        <v-card width="100%">
                            <v-alert v-if="machine_selection_error" class="error my-0 pa-2" tile>
                                <v-icon small class="pb-1">warning</v-icon>
                                <span class="subtitle-1 font-weight-medium pl-2">{{machine_selection_error}}</span>
                            </v-alert>
                            <v-btn class="float-right" fab dark small text @click="machine_selection_dialog=false">
                                <v-icon dark>mdi-close</v-icon>
                            </v-btn>
                            <v-card-title>
                                <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Update Machine Preferences</span>
                            </v-card-title>
                            <v-card-text class="py-0">
                                <v-container class="pa-0">
                                    <v-row>
                                    <v-col class="py-0" cols="4">
                                        <v-combobox
                                            v-model="machine_type_identifier"
                                            :items="selected_machine_pref && selected_machine_pref.machines || []"
                                            :label="selected_machine_pref && selected_machine_pref.operation_type_name"
                                            item-text="name"
                                            item-value="identifier"
                                            item-disabled="is_selected"
                                        ></v-combobox>
                                    </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" depressed x-small @click="update_machine_preference()">Update</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>

                <v-dialog v-model="service_plan_dialog" width="400" overlay-opacity="0.6">
                    <v-form width="250" ref="change_service_plan" lazy-validation>
                        <v-card width="100%">
                            <v-alert v-if="service_plan_error" class="error my-0 pa-2" tile>
                                <v-icon small class="pb-1">warning</v-icon>
                                <span class="subtitle-1 font-weight-medium pl-2">{{service_plan_error}}</span>
                            </v-alert>
                            <v-btn class="float-right" fab dark small text @click="service_plan_dialog=false">
                                <v-icon dark>mdi-close</v-icon>
                            </v-btn>
                            <v-card-title>
                                <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Update Service Plan</span>
                            </v-card-title>
                            <v-card-text class="py-0">
                                <v-container class="pa-0">
                                    <v-row>
                                    <v-col class="py-0" cols="4">
                                        <v-combobox
                                            v-model="service_plan"
                                            :items="service_plans || []"
                                            label="Service Plan"
                                            item-text="name"
                                            item-value="name"
                                            item-disabled="selected"
                                            @change="service_plan_changed"
                                        ></v-combobox>
                                    </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" depressed x-small @click="update_service_plan()">Update</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
import axios from 'axios';

export default {
    name: 'Profile',
    data() {
        return {
            mobile_content: false,
            linkedin_login: false,
            profile_details: [],
            profile_syncing: true,
            machine_type_identifier: null,
            machine_selection_dialog: false,
            machine_selection_error: null,
            selected_machine_pref: null,
            username_rules: [
                v => !!v || 'Value is required'
            ],
            password_rules: [
                v => !!v || 'Value is required'
            ],
            confirm_password_rules: [
                v => !!v || 'Value is required',
                v => v == this.password || 'Passwords does not match',
            ],
            throughput_rules: [
                v => !!v || 'Value is required',
                v => v > 0 || `Please enter a value between 1 & ${this.profile_details.max_throughput}`,
                v => v <= this.profile_details.max_throughput || `Please enter a value between 1 & ${this.profile_details.max_throughput}`,
            ],
            username: "",
            username_dialog: false,
            username_error: null,
            password: "",
            confirm_password: "",
            password_dialog: false,
            password_error: null,
            machine_throughput: 0,
            machine_throughput_dialog: false,
            machine_throughput_error: null,
            service_plan_error: null,
            service_plan_dialog: null,
            service_plan: null,
            service_plans: null,
        }
    },
    methods: {
        _getProfile() {
            axios.get(`https://${this.$buyerAPI}/accounts?detailed=1`)
            .then(resp => {
                this.profile_syncing = false;
                this.profile_details = resp.data.data;
                this.username = this.profile_details.name;
                this.service_plan = this.profile_details.service_plan;
                this.service_plans = this.profile_details.service_plans;
                this.machine_throughput = this.profile_details.job_throughput_limit;
                let rush_plan = {
                    can_use: true,
                    can_use_reason: "",
                    name: "Rush +",
                    selected: false
                }
                this.service_plans.push(rush_plan)
            })
            .catch(() => {})
        },
        edit_username(){
            this.username_error = null;
            this.username_dialog = true;
        },
        update_username(){
            if (this.username.trim() == ""){
                return false;
            }

            let post_json = {
                name: this.username.trim()
            }

            axios.post(`https://${this.$buyerAPI}/accounts`, post_json)
            .then(() => {
                this.username_dialog = false;
                setTimeout(()=>{
                    this._getProfile();
                }, 500)
            })
            .catch(error => {
                if (error.response){
                    this.username_error = error.response.data.error;
                }else{
                    this.username_error = error.message;
                }
            })
        },
        edit_password(){
            this.password_error = null;
            this.password_dialog = true;
        },
        update_password(){
            if(!this.$refs.change_password.validate()) {
                return false;
            }

            let post_json = {
                password: this.password
            }

            axios.post(`https://${this.$buyerAPI}/accounts`, post_json)
            .then(() => {
                this.password_dialog = false;
                let email = this.userLoggedIn.email;
                let password = this.password;
                let ispassword = true;
                this.$store.dispatch('basic_login', { email, password, ispassword })
                .then(() => {})
                .catch(() => {})
                setTimeout(()=>{
                    this._getProfile();
                }, 500)
            })
            .catch(error => {
                if (error.response){
                    this.password_error = error.response.data.error;
                }else{
                    this.password_error = error.message;
                }
            })
        },
        edit_service_plan() {
            this.service_plan_error = null;
            this.service_plan_dialog = true;
            //this.service_plan = this.profile_details.service_plan;
        },
        update_service_plan() {
            let post_json = {
                service_plan: this.service_plan.name || this.service_plan
            }

            axios.post(`https://${this.$buyerAPI}/accounts`, post_json)
            .then(() => {
                this.service_plan_dialog = false;
                setTimeout(()=>{
                    this._getProfile();
                }, 500)
            })
            .catch(error => {
                if (error.response){
                    this.service_plan_error = error.response.data.error;
                }else{
                    this.service_plan_error = error.message;
                }
            })
        },
        service_plan_changed(){
            if (this.service_plan.name == "Rush +"){
                window.open("https://www.gridmarkets.com/rush-plus");
                if (this.profile_details.service_plan != "Rush"){
                    this.service_plan = "Rush";
                    this.update_service_plan();
                }else{
                    this.service_plan_dialog = false;
                    setTimeout(()=>{
                        this._getProfile();
                    }, 500)
                }
                return false;
            }
        },
        edit_machine_throughput() {
            this.machine_throughput_error = null;
            this.machine_throughput_dialog = true;
            this.machine_throughput = this.profile_details.job_throughput_limit;
        },
        update_machine_throughput() {
            if (this.machine_throughput < 1 || this.machine_throughput > this.profile_details.max_throughput || isNaN(parseInt(this.machine_throughput))){
                return false;
            }

            let post_json = {
                job_throughput_limit : this.machine_throughput,
            }

            axios.post(`https://${this.$buyerAPI}/accounts`, post_json)
            .then(() => {
                this.machine_throughput_dialog = false;
                setTimeout(()=>{
                    this._getProfile();
                }, 500)
            })
            .catch(error => {
                if (error.response){
                    this.machine_throughput_error = error.response.data.error;
                }else{
                    this.machine_throughput_error = error.message;
                }
            })
        },
        edit_machine_prefrence(machine_pref) {
            this.machine_selection_error = null;
            this.selected_machine_pref = machine_pref;
            this.machine_selection_dialog = true;
            let selected_machine_object = machine_pref.machines.find(mach => mach.is_selected)
            this.machine_type_identifier = selected_machine_object;
        },
        update_machine_preference() {
            let post_json = {
                operation_type_id : this.selected_machine_pref.operation_type_id,
                machine_type_identifier : this.machine_type_identifier.identifier
            }

            axios.post(`https://${this.$buyerAPI}/accounts`, post_json)
            .then(() => {
                this.machine_selection_dialog = false;
                setTimeout(()=>{
                    this._getProfile();
                }, 500)
            })
            .catch(error => {
                if (error.response){
                    this.machine_selection_error = error.response.data.error;
                }else{
                    this.machine_selection_error = error.message;
                }
            })
        },
        generate_access_key(){
            let confirm_gen = confirm("Are you sure you want to generate new access key?")
            if (!confirm_gen){
                return false;
            }

            let post_json = {
                "generate_access_key": true
            }

            axios.post(`https://${this.$buyerAPI}/accounts`, post_json)
            .then(() => {
                setTimeout(()=>{
                    this._getProfile();
                }, 500)
            })
            .catch(() => {})
        }
    },
    computed : {
        userLoggedIn : function() { return this.$store.getters.userLoggedIn},
    },
    created () {
        this.profile_syncing = true;
        this._getProfile();
        if (this.userLoggedIn.linkedin_email){
            this.linkedin_login = true;
        }
        if (["xs", "sm"].indexOf(this.$vuetify.breakpoint.name) > -1){
            this.mobile_content = true;
        }
    }
}
</script>
<style scoped>

</style>